module.exports = __webpack_public_path__ + "static/img/coupon_data_none@3x.d07fab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon_data_none@3x.png
// module id = m1EN
// module chunks = 1